{
  "title": "如何設定輪次的手動輸入評分",
  "description": "讓工作人員為某個輪次輸入加分、扣分或僅記錄的欄位，並納入結果計算。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該輪次會依您選擇的模式計分：僅評審、僅工作人員輸入，或評審加上工作人員輸入，工作人員可在「手動輸入」頁輸入各隊數值。",
  "roleNote": "設定：主辦方管理員（competition.manage）；輸入：主辦方管理員或工作人員（score.manual.enter）",
  "prerequisites": ["輪次已建立", "結果尚未鎖定或公布（鎖定後不能再改模式、欄位與輸入）"],
  "pathLabel": "主辦方主控台 → 賽程輪次；審查 → 手動輸入",
  "steps": [
    {
      "title": "1. 選擇評分輸入方式",
      "description": "在「賽程輪次」頁選擇輪次的「評分輸入方式」：「僅評審評分」（預設，與原本相同）、「僅工作人員輸入」（不由評審評分）、「評審＋工作人員輸入」（以評審平均為基礎，再加減工作人員輸入）。儲存輪次後生效。"
    },
    {
      "title": "2. 新增手動輸入欄位",
      "description": "模式含工作人員時，輪次卡片會出現「手動輸入欄位」。輸入欄位名稱、最低分、最高分與計分方式：加分（加進總分）、扣分（輸入正數，從總分扣除）、僅記錄（不影響分數）。已有輸入資料的欄位只能改名，不能刪除或改範圍。"
    },
    {
      "title": "3. 開放輪次並由工作人員輸入",
      "description": "輪次狀態須為「開放中」或「評審中」。工作人員到「審查 → 手動輸入」選擇輪次，在各隊卡片輸入數值並按「儲存此隊」；超出範圍的值無法儲存。"
    },
    {
      "title": "4. 計算結果與查看明細",
      "description": "在「結果」頁計算。「評審＋工作人員輸入」的最終分數為評審平均加上加分總和、減去扣分總和，未輸入視為 0；「僅工作人員輸入」只看手動輸入，缺任一加分或扣分欄位的作品會被排除。作品詳情的「成績明細（依來源）」會標示每筆分數來自「評審」或「工作人員輸入」，並可展開修改紀錄（誰、何時、修改前後數值）。"
    }
  ],
  "afterward": ["結果頁會顯示評審分與手動調整", "結果鎖定後，模式、欄位與輸入資料都不能再修改"],
  "nextSteps": "若要查看單一作品的評分，請見「如何查看單一作品的評分」；若要計算並公布結果，請見「如何計算、鎖定並公布結果」。",
  "faq": [
    {
      "q": "「僅工作人員輸入」的輪次還能指派評審嗎？",
      "a": "不能。該輪次不接受評審評分，新增指派與自動分配都會被拒絕；既有指派不會自動取消，但評審無法再送出分數。"
    },
    {
      "q": "工作人員可以重新開啟評審的分數嗎？",
      "a": "不行。手動輸入權限（score.manual.enter）與評分管理權限（score.manage）是分開的；工作人員只能輸入手動欄位。"
    },
    {
      "q": "輸入錯了怎麼辦？",
      "a": "在結果鎖定前，工作人員可以直接更正數值；每次更正都會留下修改紀錄，包含輸入者、時間與修改前後數值。"
    },
    {
      "q": "複製或匯出競賽時會帶上這些設定嗎？",
      "a": "會。評分輸入方式與手動輸入欄位會隨設定匯出、複製與範本一起帶上，但不含任何已輸入的數值。"
    }
  ]
}
